import { NotificationList } from 'components/common/NotificationList'
import { put, takeLatest } from 'redux-saga/effects'
import {
  makeLeadsGetRequest,
  makeLeadsPostRequest,
  makeLeadsDeleteRequest,
  makeLeadsPutRequest
} from 'utils/api'
import { formatResponse, formatErrorMessage } from 'utils/formatting'

import * as ACT from './actions'
import { PUSH_NOTIFICATION } from 'actions/actionTypes'

function* fetchDealChecklists(action) {
  try {
    const { id } = action.payload
    const url = `/v1/leads/${id}/checklist`
    const checklists = yield makeLeadsGetRequest(url)

    yield put({
      type: ACT.LEAD_CHECKLISTS_FETCH_SUCCESS,
      payload: {
        checklists
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue fetching Lead Checklists',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* addDealChecklist(action) {
  const { entityId, title } = action.payload
  try {
    const url = `/v1/leads/${entityId}/checklist`
    const checklist = yield makeLeadsPostRequest(url, { title })

    yield put({
      type: ACT.CREATE_LEAD_CHECKLIST_SUCCESS,
      payload: {
        checklist
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue adding Checklist',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* updateChecklist(action) {
  const { checklistId, title } = action.payload
  try {
    const url = `/v1/leads/checklist/${checklistId}`
    const checklist = yield makeLeadsPutRequest(url, { title })

    yield put({
      type: ACT.UPDATE_LEAD_CHECKLIST_SUCCESS,
      payload: {
        checklist
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue updating Checklist',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* addDealChecklistItem(action) {
  const { checklistId, itemName } = action.payload
  try {
    const url = `/v1/leads/checklist/${checklistId}/item`
    const item = yield makeLeadsPostRequest(url, { name: itemName })

    yield put({
      type: ACT.ADD_LEAD_CHECKLIST_ITEM_SUCCESS,
      payload: {
        item,
        checklistId
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue adding Item',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* toggleChecklistItem(action) {
  const { itemId, status, checklistId, title } = action.payload
  try {
    const url = `/v1/leads/checklist/item/${itemId}`
    const item = yield makeLeadsPutRequest(url, {
      status,
      ...(title ? { name: title } : {})
    })

    yield put({
      type: ACT.LEAD_CHECKLIST_TOGGLE_ITEM_COMPLETED_SUCCESS,
      payload: {
        item,
        checklistId
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue adding Item',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* updateChecklistItem(action) {
  const { editedItem, title } = action.payload
  yield* toggleChecklistItem({
    payload: {
      itemId: editedItem.item.id,
      status: editedItem.item.status.toUpperCase(),
      checklistId: editedItem.checklistId,
      title
    }
  })
  yield put({
    type: ACT.UPDATE_LEAD_CHECKLIST_ITEM_SUCCESS
  })
}

function* deleteChecklistItem(action) {
  const { itemId, checklistId } = action.payload
  try {
    const url = `/v1/leads/checklist/${checklistId}/item/${itemId}`
    yield makeLeadsDeleteRequest(url)

    yield put({
      type: ACT.DELETE_LEAD_CHECKLIST_ITEM_SUCCESS,
      payload: {
        itemId,
        checklistId
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue deleting Item',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

function* deleteChecklist(action) {
  const { checklistId } = action.payload
  try {
    const url = `/v1/leads/checklist/${checklistId}`
    yield makeLeadsDeleteRequest(url)

    yield put({
      type: ACT.DELETE_LEAD_CHECKLIST_SUCCESS,
      payload: {
        checklistId
      }
    })
  } catch (error) {
    yield put({
      type: PUSH_NOTIFICATION,
      payload: {
        title: 'There was an issue deleting Checklist',
        message: <NotificationList lines={formatResponse(formatErrorMessage(error))} />,
        level: 'error'
      }
    })
  }
}

const leadSagas = [
  takeLatest(ACT.LEAD_CHECKLISTS_FETCH_REQUESTED, fetchDealChecklists),
  takeLatest(ACT.CREATE_LEAD_CHECKLIST_REQUESTED, addDealChecklist),
  takeLatest(ACT.ADD_LEAD_CHECKLIST_ITEM_REQUESTED, addDealChecklistItem),
  takeLatest(ACT.LEAD_CHECKLIST_TOGGLE_ITEM_COMPLETED_REQUESTED, toggleChecklistItem),
  takeLatest(ACT.DELETE_LEAD_CHECKLIST_ITEM_REQUESTED, deleteChecklistItem),
  takeLatest(ACT.DELETE_LEAD_CHECKLIST_REQUESTED, deleteChecklist),
  takeLatest(ACT.UPDATE_LEAD_CHECKLIST_REQUESTED, updateChecklist),
  takeLatest(ACT.UPDATE_LEAD_CHECKLIST_ITEM_REQUESTED, updateChecklistItem)
]

export default leadSagas
